
    import './styles.scoped.css';
    export default {
  "options-list": "awsui_options-list_19gcf_1jzon_94",
  "decrease-top-margin": "awsui_decrease-top-margin_19gcf_1jzon_114"
};
  